import { EventHint, TransactionEvent } from '@sentry/core/build/types-ts3.8/types-hoist/event';
import * as Sentry from '@sentry/react';

export const setupSentry = () => {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
		sampleRate: 0.1,
		tracesSampleRate: 0.1,
		environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local',
		sendDefaultPii: true,
		integrations: [Sentry.browserTracingIntegration()],
		ignoreErrors: [
			'optimoveSDK is not defined',
			"Can't find variable: optimoveSDK",
			'AxiosError: Network Error',
			'Large Render Blocking Asset',
			'Minified exception occurred',
			"TypeError: Cannot read properties of undefined (reading 'trigger')",
			'window.clarity is not a function',
		],
		beforeSendTransaction: (event: TransactionEvent, hint: EventHint) => {
			// Filter out most of the spans to avoid running out of span quota.
			event.spans = event.spans?.filter((span) => {
				if (span.op === 'mark') {
					if (span.description?.startsWith('GTM-G-')) {
						return false;
					}

					// This is most likely required for web vitals to work
					return true;
				}

				if (span.op === 'paint') {
					// This is most likely required for web vitals to work
					return true;
				}

				if (span.op?.startsWith('ui.')) {
					// Report user interactions such as clicks but ignore long task reports
					if (['ui.long-animation-frame', 'ui.long-task'].includes(span.op)) {
						return false;
					}

					return true;
				}

				if (span.op === 'http.client') {
					// Only report failed requests
					if (span.data['http.response.status_code'] && span.data['http.response.status_code'] < 400) {
						return false;
					}

					return true;
				}

				return false;
			});

			return event;
		},
	});
};
